import { createOperation } from "../operations";

export const getAnotherRoundOperation = createOperation<string[] | null>("PARTY/GET_ANOTHER_ROUND");
